import { AppName, type CategoryEventListViewModel } from "src/http/types";
import { usePageModelData } from "src/shared/context/PageModelDataContext";

/*
 * WARNING - DO NOT MOVE THIS FILE
 * This file location is important to ensure our linting enforces we avoid unsafely accessing page model data
 * across different applications and shared components within this repo.
 */

/**
 * Returns the page model data specifically for the category grouping page.
 */
export const useCategoryGroupingPageModelData = (): CategoryEventListViewModel => {
  const data = usePageModelData();
  if (data.appName !== AppName.Category) {
    throw new Error("useCategoryGroupingPageModelData must be used on the category grouping page only");
  }
  return data;
};
